import { render, staticRenderFns } from "./PartnerPrize.vue?vue&type=template&id=6d2d59b6&scoped=true&"
import script from "./PartnerPrize.vue?vue&type=script&lang=js&"
export * from "./PartnerPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d59b6",
  null
  
)

export default component.exports